<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>存货产品禁售名单</span>
          <span class="muted small" style="margin-left:10px">展开 customer.forbiddenProducts，列出所有 (客户, 禁售产品) 条目</span>
          <div style="float: right">
            <el-button type="success" size="small" icon="el-icon-download" @click="exportCsv">导出CSV</el-button>
            <el-button size="small" icon="el-icon-refresh" @click="loadList">刷新</el-button>
          </div>
        </div>
      </template>

      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item label="客户姓名">
          <el-input v-model="searchForm.customerName" placeholder="请输入" clearable style="width: 180px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="searchForm.productName" placeholder="请输入" clearable style="width: 180px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">筛选</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="pagedGroupedRows" stripe size="small" border v-loading="loading">
        <el-table-column type="index" label="序号" width="70" align="center" fixed="left" :index="idx => (page1 - 1) * size1 + idx + 1"></el-table-column>
        <el-table-column label="客户负责人" prop="responsiblePerson" width="130">
          <template slot-scope="{ row }">{{ row.responsiblePerson || '-' }}</template>
        </el-table-column>
        <el-table-column label="客户姓名" prop="customerName" width="120"></el-table-column>
        <el-table-column label="电话" prop="phone" width="140"></el-table-column>
        <el-table-column label="禁售产品" :min-width="forbidColMinWidth">
          <template slot-scope="{ row }">
            <el-tag v-for="p in row.products" :key="p" :closable="$hasPerm('func:forbidden-list:remove')" size="small"
                    :type="p === '全部' ? 'danger' : 'warning'"
                    style="margin:2px 6px 2px 0"
                    @close="unban(row, p)">{{ p }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="160" align="center">
          <template slot-scope="{ row }">{{ formatDate(row.updateTime) }}</template>
        </el-table-column>
        <el-table-column label="客户ID" prop="customerId" width="100" align="center"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="v => { size1 = v; page1 = 1 }"
        @current-change="v => page1 = v"
        :current-page="page1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="size1"
        layout="total, sizes, prev, pager, next, jumper"
        :total="groupedRows.length"
        style="margin-top:16px; text-align:right">
      </el-pagination>
    </el-card>

    <!-- 金额禁售名单 -->
    <el-card shadow="hover" style="margin-top:16px">
      <template slot="header">
        <div class="clearfix">
          <span>金额禁售名单</span>
          <span class="muted small" style="margin-left:10px">客户年度订单总金额超限被自动列入禁售</span>
          <div style="float: right">
            <el-button size="small" icon="el-icon-refresh" @click="loadAmountBanList">刷新</el-button>
          </div>
        </div>
      </template>

      <el-form :inline="true" :model="amountBanSearch" class="mb-4">
        <el-form-item label="客户姓名">
          <el-input v-model="amountBanSearch.customerName" placeholder="请输入" clearable style="width: 180px" @keyup.enter.native="loadAmountBanList"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadAmountBanList">筛选</el-button>
          <el-button @click="amountBanSearch = { customerName: '' }; loadAmountBanList()">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="pagedAmountBanList" stripe size="small" border v-loading="amountBanLoading">
        <el-table-column type="index" label="序号" width="70" align="center" :index="idx => (page2 - 1) * size2 + idx + 1"></el-table-column>
        <el-table-column label="客户负责人" prop="responsiblePerson" min-width="130">
          <template slot-scope="{ row }">{{ row.responsiblePerson || '-' }}</template>
        </el-table-column>
        <el-table-column label="客户姓名" prop="name" min-width="150"></el-table-column>
        <el-table-column label="电话" prop="phone" min-width="140"></el-table-column>
        <el-table-column label="禁售年份" prop="amountBanYear" width="100" align="center"></el-table-column>
        <el-table-column label="年度总计金额" width="150" align="right">
          <template slot-scope="{ row }">
            <span v-if="row.yearTotalAmount != null">{{ Number(row.yearTotalAmount).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="禁售状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag type="danger" size="small">已禁售</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" v-if="isSuperAdmin || $hasPerm('func:forbidden-list:unlift-amount-ban')">
          <template slot-scope="{ row }">
            <el-button type="success" size="mini" @click="unliftAmountBan(row)">解除禁售</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="v => { size2 = v; page2 = 1 }"
        @current-change="v => page2 = v"
        :current-page="page2"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="size2"
        layout="total, sizes, prev, pager, next, jumper"
        :total="amountBanList.length"
        style="margin-top:16px; text-align:right">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ForbiddenList',
  data() {
    return {
      rows: [],
      loading: false,
      searchForm: { customerName: '', productName: '' },
      page1: 1,
      size1: 20,
      amountBanList: [],
      amountBanLoading: false,
      amountBanSearch: { customerName: '' },
      page2: 1,
      size2: 20
    }
  },
  mounted() {
    this.loadList()
    this.loadAmountBanList()
  },
  computed: {
    groupedRows() {
      const map = {}
      for (const r of this.rows) {
        const key = r.customerId
        if (!map[key]) {
          map[key] = {
            customerId: r.customerId, customerName: r.customerName, phone: r.phone,
            responsiblePerson: r.responsiblePerson, updateTime: r.updateTime, products: []
          }
        }
        if (!map[key].products.includes(r.productName)) map[key].products.push(r.productName)
      }
      return Object.values(map).sort((a, b) => {
        const ra = a.responsiblePerson || ''
        const rb = b.responsiblePerson || ''
        // 空负责人排到最后
        if (!ra && rb) return 1
        if (ra && !rb) return -1
        const c = ra.localeCompare(rb, 'zh')
        return c !== 0 ? c : (a.customerId - b.customerId)
      })
    },
    pagedGroupedRows() {
      const start = (this.page1 - 1) * this.size1
      const end = start + this.size1
      return this.groupedRows.slice(start, end)
    },
    pagedAmountBanList() {
      const start = (this.page2 - 1) * this.size2
      const end = start + this.size2
      return this.amountBanList.slice(start, end)
    },
    forbidColMinWidth() {
      // 按数据中最长一行估算：每个产品标签 ≈ tag padding(20) + 字符宽(中文≈14, 英文≈8) + 间距(6)
      let max = 0
      for (const r of this.groupedRows) {
        let w = 0
        for (const p of (r.products || [])) {
          let cw = 0
          for (const ch of p) cw += /[一-鿿]/.test(ch) ? 14 : 8
          w += 20 + cw + 6
        }
        if (w > max) max = w
      }
      return Math.min(900, Math.max(180, max + 16))
    },
    isSuperAdmin() {
      const me = (function () { try { return JSON.parse(sessionStorage.getItem('user') || '{}') } catch (e) { return {} } })()
      return me && (me.role === 'super_admin' || me.role === '超级管理员' || Number(me.roleId) === 1)
    }
  },
  methods: {
    loadList() {
      this.loading = true
      const params = {}
      if (this.searchForm.customerName) params.customerName = this.searchForm.customerName
      if (this.searchForm.productName) params.productName = this.searchForm.productName
      // 行政管理员仅看自己客户的禁售（自己客户 = responsiblePerson=自己 ∪ approverId=自己 关联的客户）
      const me = (function () { try { return JSON.parse(sessionStorage.getItem('user') || '{}') } catch (e) { return {} } })()
      const isSuper = me && (me.role === 'super_admin' || me.role === '超级管理员' || Number(me.roleId) === 1)
      const isAdmin = me && !isSuper && (me.role === 'admin' || Number(me.roleId) === 2)
      const isSales = me && !isSuper && !isAdmin && Number(me.roleId) === 3
      if (isAdmin && me.id) params.mineForUserId = me.id
      // 业务员仅看自己客户的禁售（我负责 ∪ 我建 ∪ 我提交过出库）
      if (isSales && me.id) params.salesmanUserId = me.id
      axios.get('/customer/forbidden-list', { params }).then(res => {
        const list = Array.isArray(res.data) ? res.data : []
        this.rows = list.filter(r => r.productName !== '全部')
      }).finally(() => { this.loading = false })
    },
    handleSearch() { this.loadList() },
    resetSearch() { this.searchForm = { customerName: '', productName: '' }; this.loadList() },
    unban(row, productName) {
      this.$confirm('确定解除客户「' + row.customerName + '」对【' + productName + '】的禁售？', '提示', { type: 'warning' }).then(() => {
        axios.get('/customer/' + row.customerId).then(res => {
          const c = res.data || {}
          const current = (c.forbiddenProducts || '').split(/[,，]/).map(s => s.trim()).filter(Boolean)
          const next = current.filter(p => p !== productName)
          return axios.put('/customer/forbidden/' + row.customerId, { forbiddenProducts: next.join(',') })
        }).then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success('已解除')
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '操作失败')
          }
        })
      }).catch(() => {})
    },
    formatDate(v) { return v ? String(v).replace('T', ' ').slice(0, 10) : '-' },
    loadAmountBanList() {
      this.amountBanLoading = true
      const params = { amountBanStatus: 1 }
      if (this.amountBanSearch.customerName) params.customerName = this.amountBanSearch.customerName
      // 行政管理员/业务员权限过滤
      const me = (function () { try { return JSON.parse(sessionStorage.getItem('user') || '{}') } catch (e) { return {} } })()
      const isSuper = me && (me.role === 'super_admin' || me.role === '超级管理员' || Number(me.roleId) === 1)
      const isAdmin = me && !isSuper && (me.role === 'admin' || Number(me.roleId) === 2)
      const isSales = me && !isSuper && !isAdmin && Number(me.roleId) === 3
      if (isAdmin && me.id) params.mineForUserId = me.id
      if (isSales && me.id) params.salesmanUserId = me.id
      axios.get('/customer/list', { params }).then(res => {
        this.amountBanList = Array.isArray(res.data) ? res.data.filter(c => c.amountBanStatus === 1) : []
      }).finally(() => { this.amountBanLoading = false })
    },
    unliftAmountBan(row) {
      this.$confirm('确定解除客户「' + row.name + '」的金额禁售吗？解除后该客户可继续录入销售订单。', '提示', { type: 'warning' }).then(() => {
        axios.put('/customer', { id: row.id, amountBanStatus: 0 }).then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success('已解除金额禁售')
            this.loadAmountBanList()
          } else {
            this.$message.error((res.data && res.data.message) || '操作失败')
          }
        })
      }).catch(() => {})
    },
    exportCsv() {
      const cols = ['客户ID', '客户姓名', '电话', '客户负责人', '禁售产品', '更新时间']
      const rows = this.groupedRows.map(r => [
        r.customerId, r.customerName || '', r.phone || '',
        r.responsiblePerson || '',
        (r.products || []).join('；'),
        this.formatDate(r.updateTime)
      ].map(v => v == null ? '' : String(v).replace(/,/g, '，')))
      const csv = '﻿' + [cols.join(','), ...rows.map(r => r.join(','))].join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '禁售名单_' + new Date().toISOString().slice(0, 10) + '.csv'
      link.click()
    }
  }
}
</script>

<style scoped>
.muted { color: #909399; }
.small { font-size: 12px; }
.mb-4 { margin-bottom: 16px; }
</style>
